import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { colors, fontSize } from "style";

/**
 * Rate
 *
 * @param {String} rate
 * @param {String} labelId
 * @param {String} messageId
 */
const Rate = ({ rate, labelId, messageId, ...props }) => {
  return (
    <div css={styles.rate_container} {...props}>
      <span css={styles.rate_label}>
        <FormattedMessage id={labelId} />
      </span>
      <span css={styles.rate_amount}>
        <FormattedMessage
          id="Missions.Applicants.ApplicantRate"
          values={{
            rate: <span css={styles.rate}>{rate}</span>,
            period: <FormattedMessage id={messageId} />,
          }}
        />
      </span>
    </div>
  );
};

const styles = {
  rate_container: css`
    border: 1px ${colors.grayAnatomyLight2} solid;
    border-radius: 1.6rem;
    color: ${colors.purpleRainDark2};
    background: ${colors.grayAnatomyLight3};
    display: inline-flex;
    font-size: 1.2rem;
    font-weight: 400;
    font-size: ${fontSize.xxsmall};
    box-shadow: 0px 1px 3px ${colors.grayAnatomyLight5};
    box-sizing: border-box;
    width: 13rem;
  `,
  rate_amount: css`
    padding: 0rem 0rem 0rem 0.5rem;
    border-radius: 0 1.6rem 1.6rem 0;
    background: #fff;
    flex: 1;
    height: 2.2rem;
    line-height: 2.2rem;
  `,
  rate_label: css`
    border-right: 1px solid ${colors.grayAnatomyLight2};
    padding: 0rem 0.5rem 0rem 1rem;
    font-weight: 500;
    width: 3.5rem;
    text-align: right;
    height: 2.2rem;
    line-height: 2.2rem;
  `,
};

Rate.defaultProps = {
  messageId: "Global.PerHour",
};

Rate.propTypes = {
  rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  messageId: PropTypes.string,
  labelId: PropTypes.string.isRequired,
};

export default Rate;
